import { render } from "./EditAssociationForm.vue?vue&type=template&id=2b31f831&scoped=true"
import script from "./EditAssociationForm.vue?vue&type=script&lang=js"
export * from "./EditAssociationForm.vue?vue&type=script&lang=js"

import "./EditAssociationForm.vue?vue&type=style&index=0&id=2b31f831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b31f831"]])

export default __exports__